import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import fetch from './fetch';
import applications from './applications';
import workflow from './workflow';

const createRootReducer = history => combineReducers({
  router: connectRouter(history),
  applications,
  fetch,
  workflow,
});

export default createRootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js